var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loading ? _vm.theme() || "" : null
  var m1 = !_vm.loading ? _vm.theme() : null
  var l0 = !_vm.loading
    ? _vm.__map(_vm.ProductData, function (supplier_item, supplier_index) {
        var $orig = _vm.__get_orig(supplier_item)
        var m2 =
          !(_vm.options.order_type == "deposit") && !_vm.OrderData.force_points
            ? _vm.objKeys(supplier_item.orderData.couponList, 1)
            : null
        var m3 =
          !(_vm.options.order_type == "deposit") &&
          !_vm.OrderData.force_points &&
          m2 > 0 &&
          !(supplier_item.orderData.coupon_money > 0)
            ? _vm.objKeys(supplier_item.orderData.couponList, 1)
            : null
        var m4 =
          !(_vm.options.order_type == "deposit") &&
          _vm.is_use_points == 1 &&
          !_vm.OrderData.force_points &&
          supplier_item.orderData.points_money > 0
            ? _vm.points_name()
            : null
        var g0 = !(_vm.options.order_type == "deposit")
          ? supplier_item.productList.length
          : null
        var m5 =
          !(_vm.options.order_type == "deposit") && !_vm.OrderData.force_points
            ? _vm.toDecimal2(supplier_item.orderData.order_pay_price)
            : null
        return {
          $orig: $orig,
          m2: m2,
          m3: m3,
          m4: m4,
          g0: g0,
          m5: m5,
        }
      })
    : null
  var m6 =
    !_vm.loading &&
    _vm.options.order_type != "deposit" &&
    _vm.OrderData.is_allow_points &&
    _vm.OrderData.force_points == false &&
    _vm.OrderData.points_money != 0
      ? _vm.points_name()
      : null
  var m7 =
    !_vm.loading &&
    _vm.options.order_type != "deposit" &&
    _vm.OrderData.is_allow_points &&
    _vm.OrderData.force_points == false &&
    _vm.OrderData.points_money != 0
      ? _vm.toDecimal2(_vm.OrderData.points_money)
      : null
  var m8 =
    !_vm.loading &&
    !(_vm.options.order_type == "deposit") &&
    _vm.OrderData.force_points
      ? _vm.points_name()
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
        m6: m6,
        m7: m7,
        m8: m8,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }